import React,{useContext} from 'react';
import { makeStyles,useTheme } from '@material-ui/core/styles';
import About from '../Screens/About.jsx';
import Home from '../Screens/Home.jsx';
import Skills from '../Screens/Skills.jsx';
import Works from '../Screens/Works.jsx';
import Contact from '../Screens/Contact.jsx';
import Error404 from '../Screens/Error404.jsx';
import { Route, Switch } from 'react-router-dom';
import UserContext from '../context/UserContext';
import clsx from 'clsx';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PVUCalculator from '../Screens/PVUCalculator.jsx';



const drawerWidth=320;

const useStyles = makeStyles((theme) => ({
    content: {
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
          padding: theme.spacing(3),
        }),
        marginLeft: 0,
      },
      contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
      },
      drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
      },

  }));

function MainContainer() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

    const {State } =useContext(UserContext);
    const theme = useTheme();
    const classes=useStyles();
    
    return (
      
        <main style={{height:'100%',minHeight: '100vh',paddingLeft:'30px',backgroundColor:prefersDarkMode?'#1A1A2E':'white'}}
        className={clsx(classes.content, {
          [classes.contentShift]: State.DrawerState,
        })}
      >      
         <div className={classes.drawerHeader} />
        
           <Switch>
          <Route exact from="/" render ={props=><Home{...props}/>}/>
          <Route exact from="/About" render ={props=><About{...props}/>}/>
          <Route exact from="/Skills" render ={props=><Skills{...props}/>}/>
          <Route exact from="/Works" render ={props=><Works{...props}/>}/>
          <Route exact from="/Contact" render ={props=><Contact{...props}/>}/>
          <Route exact from="/PVUCalculator" render ={props=><PVUCalculator{...props}/>}/>
          <Route path="*" render={props=><Error404{...props}/>}/>
        </Switch>
        </main>
    )
}

export default MainContainer
